<template>
  <el-dialog
      class="select-dialog"
      title="移动"
      :visible.sync="dialogVisible"
      width="50%"
      top="10px"
      append-to-body>
    <div style="width: 100%; margin: 10px; overflow:hidden;">
      <el-tree
          ref="tree"
          v-loading="contentLoading"
          :data="data"
          :props="defaultProps"
          node-key="id"
          :expand-on-click-node="false">
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <div style="width: 100%;" @click="onSelect(data)"><span>&nbsp;{{node.label}}</span></div>
        </span>
      </el-tree>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    name:"PanRemoveDialog",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        data: [],
        defaultProps: {
          children: "children",
          label: "name",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.contentLoading = true;
        this.getData();
      },
      getData() {
        let Params = {
          flag: 1,
        };
        this.$http
          .get("basic","pans/tree", Params).then((res) => {
            if (res) {
              this.data = JSON.parse(JSON.stringify(res));
            } else {
              this.$message.error("获取数据出错");
            }
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
      },
      onSelect(data) {
        this.$confirm("确定移动到[ " + data.name + " ]吗?", "提示", {type: "warning"}).then(() => {
          this.$emit("select", {"id": data.id, "name": data.name});
          this.dialogVisible = false;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
